import { IAPIResponseError, IError } from '@checkout/errors';
import { IPersonalIdentityNumberFetchSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { PersonalIdentityNumberFetchRequestAction, RootAction } from '../actions/actionTypes.d';
import convertMessages from '../utils/convertErrors';
import ActionTypes from './../actions/actionTypes';
import { personalIdentityNumberFetchSuccess, responseError, setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const personalIdentityNumberFetchEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.PERSONAL_IDENTITY_NUMBER_FETCH_REQUEST)
    .mergeMap((action: PersonalIdentityNumberFetchRequestAction) => {
      return fromPromise$(rest.httpPost('/address-search',
          { paymentMethod:  action.payload.paymentMethod, identityNumber: action.payload.identityNumber }))
        .flatMap((response: AxiosResponse<IPersonalIdentityNumberFetchSuccessPayload>) => {
          return of$(personalIdentityNumberFetchSuccess(response.data));
        })
        .catch((error: IError) => {
          logger(error);
          if (error.response && error.response.data) {
            const convertedMessages = convertMessages(error.response.data, state$.value.checkout.intlData, 'inline');
            const responseApiErrorPayload: IAPIResponseError = {
              errors: convertedMessages,
              selection: error.response.data.selection,
            };
            return of$(responseError(responseApiErrorPayload));
          }
          return of$(setErrors(error));
        });
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/personalIdentityNumber.ts